import { render, staticRenderFns } from "./colorpicker.vue?vue&type=template&id=f6674334&"
import script from "./colorpicker.vue?vue&type=script&lang=js&"
export * from "./colorpicker.vue?vue&type=script&lang=js&"
import style0 from "./colorpicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports